export const repeatingFractions = {
  [333]: '1/3',
  [666]: '2/3',
  [111]: '1/9',
  [166]: '1/6',
  [833]: '5/6'
} as { [key: string]: string };
